import { Button, useToast } from "@chakra-ui/react";
import { adminHideCampaign, adminShowCampaign } from "../api";

const errorMessage = (e) =>
  e?.response?.data?.error?.message ||
  e?.response?.data?.message ||
  e?.response?.data?.detail ||
  "캠페인 상태 변경 중 오류가 발생했습니다.";

export default function CampaignVisibilityControl({
  campaignId,
  hidden,
  onChanged,
  size = "md",
}) {
  const toast = useToast();

  const handleClick = async () => {
    if (!campaignId) return;
    try {
      if (hidden) {
        await adminShowCampaign({ id: campaignId });
      } else {
        await adminHideCampaign({ id: campaignId });
      }
      toast({
        title: hidden ? "캠페인을 노출했습니다." : "캠페인을 숨김 처리했습니다.",
        status: "success",
        duration: 1800,
        isClosable: true,
      });
      onChanged?.(!hidden);
    } catch (e) {
      toast({
        title: "상태 변경 실패",
        description: errorMessage(e),
        status: "error",
        duration: 2500,
        isClosable: true,
      });
    }
  };

  return (
    <Button
      size={size}
      variant="outline"
      colorScheme={hidden ? "green" : "red"}
      flexShrink={0}
      onClick={handleClick}
      isDisabled={!campaignId}
    >
      {hidden ? "노출하기" : "숨기기"}
    </Button>
  );
}
